import React from "react";
import { Show, SimpleShowLayout, TextField } from "react-admin";
import ExcelImportErrors from "../../src/components/ExcelImportErrors";

const CompanyTitle = ({ record }) => {
  return (
    <span>
      Company {record.name} - {record.email}
    </span>
  );
};

export default (props) => (
  <Show title={<CompanyTitle sourse="name" />} {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <ExcelImportErrors source="wrongExcelImportHistory" />
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/companies/Show.js